import { render, staticRenderFns } from "./SampleFileView.vue?vue&type=template&id=97b0e8ce&"
import script from "./SampleFileView.vue?vue&type=script&lang=js&"
export * from "./SampleFileView.vue?vue&type=script&lang=js&"
import style0 from "./SampleFileView.vue?vue&type=style&index=0&id=97b0e8ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports